module.exports = __webpack_public_path__ + "static/mobileNotifications-bf034965bda1aaeb1e710541b4cd2052.png";